import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRegionByCode, getRegionFromPath } from '../data/regions';

const RegionContext = createContext();

export const useRegion = () => {
  const context = useContext(RegionContext);
  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
};

export const RegionProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentRegion, setCurrentRegion] = useState('global');

  useEffect(() => {
    const regionCode = getRegionFromPath(location.pathname);
    setCurrentRegion(regionCode);
  }, [location.pathname]);

  const changeRegion = (newRegionCode) => {
    const newRegion = getRegionByCode(newRegionCode);
    if (!newRegion.enabled) return;

    const currentPath = location.pathname;
    let newPath = currentPath;

    // Remove current region prefix if exists
    if (currentRegion !== 'global') {
      newPath = currentPath.replace(new RegExp(`^/${currentRegion}`), '');
    }

    // Add new region prefix if not global
    if (newRegionCode !== 'global') {
      newPath = `/${newRegionCode}${newPath || '/'}`;
    } else {
      newPath = newPath || '/';
    }

    navigate(newPath);
  };

  const region = getRegionByCode(currentRegion);

  return (
    <RegionContext.Provider value={{ currentRegion, region, changeRegion }}>
      {children}
    </RegionContext.Provider>
  );
};
